import { Row } from "@tanstack/react-table";

import {
    PartialUpdateTarget,
    PatchUsersUserIdControlsBody,
} from "api/generated/model";

import { ControlRow } from "./useUserAssignedControlListTable";

/**
 * Builds the PATCH body for reassigning/unassigning the selected control rows.
 *
 * The body is nested by control -> assignment group -> step:
 *   { [controlId]: { partialAssignmentChanges: { [groupId]: { [step]: target } } } }
 *
 * `target` is the new assignee for a replace, or `null` to unassign (remove).
 * Several selected rows can belong to the same control/group, so each level is
 * created the first time it is seen and reused afterwards.
 */
export function buildPatchAssignmentBody(
    selectedRows: Row<ControlRow>[],
    target: PartialUpdateTarget | null
): PatchUsersUserIdControlsBody {
    const body: PatchUsersUserIdControlsBody = {};

    selectedRows.forEach(({ original }) => {
        const { controlId, assignmentGroupId, stepIndex } = original;

        if (!body[controlId]) {
            body[controlId] = { partialAssignmentChanges: {} };
        }
        const assignmentChanges = body[controlId].partialAssignmentChanges;

        if (!assignmentChanges[assignmentGroupId]) {
            assignmentChanges[assignmentGroupId] = {};
        }

        // Record the new assignee for this step (`null` means unassign).
        assignmentChanges[assignmentGroupId][stepIndex] = target;
    });

    return body;
}
